

























































































import { Component, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';

import { GroupPurchaseOrder } from 'frontend/types/premium/group-plans';

import Button from 'frontend/components/Button.vue';
import Modal from 'frontend/components/Modal.vue';
import GroupPlansModalContent from 'frontend/views/premium/group-plans/GroupPlansModalContent.vue';
import PageContent from 'frontend/views/premium/paywall/PageContent.vue';
import PaywallFooterCta from 'frontend/views/premium/paywall/PaywallFooterCta.vue';
import GroupPaywallIllustration from 'frontend/views/premium/group-plans/svgs/GroupPaywallIllustration.vue';

@Component({
  components: {
    Modal,
    GroupPlansModalContent,
    PageContent,
    PaywallFooterCta,
    GroupPaywallIllustration,
    Button,
  },
  computed: {
    ...mapState('groupPurchaseInfo', ['cannot_purchase_reason']),
    ...mapState('groupPurchasePricing', [
      'seat_count_minimum',
      'seat_count_maximum',
      'monthly_price_minimum_seats_per_seat',
    ]),
    ...mapGetters('pageHeader', ['isMobile']),
  },
  metaInfo() {
    return { title: 'Group plans' };
  },
})
export default class GroupPlans extends Vue {
  private showModal = false;

  private isModalScrollable(): boolean {
    // This part should never happen on the server, but adding this just in case
    if (process.env.VUE_ENV === 'server') {
      return false;
    }
    // The modal only needs to be scrollable on small screens
    return document.body.clientWidth < 375;
  }

  private handlePurchaseOrder({ purchaseOrder }: { purchaseOrder: GroupPurchaseOrder }) {
    if (purchaseOrder.need_to_revisit) {
      this.$store.dispatch('signupModal/signup', purchaseOrder.revisit_path);
    } else if (purchaseOrder.chargebee_plan) {
      window.location.href = purchaseOrder.chargebee_plan.checkout_url;
    }
  }

  private mounted(): void {
    if (this.$route.hash === '#choose-group-type') {
      this.showModal = true;
    }
  }
}
